import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Logo } from "@/components/Shared";
import { ArrowLeft } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="mb-8">
          <Logo height="h-20" />
        </div>
        <h1 className="text-2xl font-heading font-semibold tracking-tight">Reset your password</h1>
        {sent ? (
          <p className="text-sm text-muted-foreground mt-3" data-testid="forgot-confirmation">
            If that email is registered, a reset link has been sent. Check your inbox and spam folder.
          </p>
        ) : (
          <>
            <p className="text-sm text-muted-foreground mt-1.5">Enter your email and we'll send a reset link.</p>
            <form onSubmit={submit} className="space-y-4 mt-6">
              <div className="space-y-1.5">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" data-testid="forgot-email-input" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-11" />
              </div>
              <Button type="submit" disabled={busy} data-testid="forgot-submit-button" className="w-full h-11 bg-primary hover:bg-primary/90">
                {busy ? "Sending…" : "Send reset link"}
              </Button>
            </form>
          </>
        )}
        <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-primary hover:underline mt-6">
          <ArrowLeft size={15} /> Back to sign in
        </Link>
      </div>
    </div>
  );
}
